import { useCookieConsent } from '@/lib/cookie-consent';
import { Button } from '@/components/ui/button';
import { Cookie } from 'lucide-react';

export function CookieBanner() {
  const { hasConsented, acceptAll, rejectAll, openSettings } = useCookieConsent();

  if (hasConsented) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9998] p-4 animate-in slide-in-from-bottom-4 duration-500">
      <div className="container mx-auto max-w-4xl">
        <div className="rounded-xl border border-border bg-card/95 backdrop-blur-md shadow-2xl p-5 sm:p-6">
          <div className="flex items-start gap-4">
            <Cookie className="h-6 w-6 text-primary shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground mb-1">
                Utilizamos cookies
              </h3>
              <p className="text-xs text-muted-foreground leading-relaxed mb-4">
                Este site utiliza cookies para garantir o funcionamento essencial, guardar as suas preferências
                e, futuramente, analisar o tráfego. Pode aceitar todos, rejeitar os não essenciais
                ou personalizar as suas escolhas.
              </p>
              <div className="flex flex-wrap gap-2">
                <Button size="sm" onClick={acceptAll}>
                  Aceitar Todos
                </Button>
                <Button size="sm" variant="outline" onClick={rejectAll}>
                  Rejeitar Todos
                </Button>
                <Button size="sm" variant="ghost" onClick={openSettings}>
                  Personalizar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
